export const formName = 'frm_client_view'
export const risksObjectName = 'dbgrd_risklevels'
export const amlOfficersObjectName = 'dbgrd_aml_records'

export const clientSearch = 'RelationshipsClientSearch'
export const clientSearchModal = 'RelationshipsClientSearchModal'

export const delegateClientSearch = 'delegateClientSearch'
export const delegateClientSearchModal = 'delegateClientSearchModal'

export const validationPinCodeFetcher = 'validationPinCodeFetcher'
export const validationPinCodeConfModal = 'validationPinCodeConfModal'

export const addRelationModal = 'RelationshipsClientSearch'
export const addRelationForm = 'addRelationForm'
export const addRelationFetcher = 'addRelationFetcher'

export const deleteClientRelationFetcher = 'deleteClientRelationFetcher'
export const deleteClientRelationConfModal = 'deleteClientRelationConfModal'

export const addNoteModalName = 'addNoteModal'
export const addNoteFormName = 'addNoteForm'

export const editNoteModalName = 'editNoteModal'
export const editNoteFormName = 'editNoteForm'
export const editNoteFetcher = 'editNoteFetcher'

export const activeNotesModalName = 'activeNotesModal'

export const deleteNoteModalName = 'deleteNoteModalName'

export const SMS_FORM_NAME = 'ClientViewSMS'
export const ENTRIES_FORM_NAME = 'ClientViewEntries'

// delegates add
export const addDelegateModalName = 'addDelegateModal'
export const addDelegateFormName = 'addDelegateForm'

// delegates view
export const viewDelegateModalName = 'viewDelegateModal'

// delegates edit
export const editDelegateModalName = 'editDelegateModal'
export const editDelegateFormName = 'editDelegateForm'

// delegates delete
export const deleteDelegateModalName = 'deleteDelegateModal'

export enum clientTypes {
  PHYSICAL = 1,
  GROUP,
  ORGANIZATION,
}

export enum modalActionTypes {
  ADD = 'ADD',
  EDIT = 'EDIT',
  PREVIEW = 'PREVIEW',
}
